import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TacsCodeKreis } from '@entity/tacs-code-kreis';

@Injectable({
  providedIn: 'root',
})
export class TacsCodeKreisService {
  private httpClient = inject(HttpClient);

  private readonly baseUrl = `api/1.0/tacscodekreis`;

  getTacsCodeKreis(variablenartId: number): Observable<TacsCodeKreis[]> {
    const params = new HttpParams().append('variablenartId', variablenartId + '');
    return this.httpClient.get<TacsCodeKreis[]>(this.baseUrl, { params });
  }
}
